import { IsNotEmpty, IsString } from 'class-validator';

export class FormCommonSectionDto {
  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  name: string;
}
